import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTHORIZE_TOKEN,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  DELETE_USER,
  DELETE_USER_ERROR,
  CLEAR_MSG,
  DELETE_USER_ACCOUNT,
  DELETE_USER_ACCOUNT_ERROR,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  isAuthenticated: false,
  isRegistered: false,
  channelid: "",
  firstname: "",
  lastname: "",
  jobtitle: "",
  companyname: "",
  msg: "",
  location: {},
  verified: false,
  redirected: false,
  loading: true,
  user: {},
  users: [],
  subscription: false,
  posts: [],
  articles: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        redirected: true,
        loading: false,
        user: payload,
      };
    case AUTHORIZE_TOKEN:
      localStorage.setItem("token", payload.token);
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
      };
    case LOGIN_SUCCESS:
      if (payload.token) {
        localStorage.setItem("token", payload.token);
        return {
          ...state,
          ...payload,
          isAuthenticated: true,
          loading: false,
        };
      } else {
        localStorage.setItem("token", payload.token);
        return {
          ...state,
          channelid: payload.channelid,
          firstname: payload.firstname,
          lastname: payload.lastname,
          jobtitle: payload.jobtitle,
          companyname: payload.companyname,
          location: payload.location,
          verified: payload.verified,
          isAuthenticated: payload.isAuthenticated,
          loading: false,
        };
      }
    case REGISTER_SUCCESS:
      localStorage.setItem("token", payload.token);
      return {
        ...state,
        ...payload,
        isRegistered: true,
        isAuthenticated: false,
        loading: false,
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        users: payload,
        isRegistered: true,
        isAuthenticated: false,
        loading: false,
      };
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem("token");
      return {
        ...state,
        msg: payload && payload !== "" ? payload : "",
        user: {},
        token: null,
        isAuthenticated: false,
        verified: false,
      };
    case DELETE_USER_ACCOUNT:
      localStorage.removeItem("token");
      return {
        ...state,
        msg: payload.msg ? payload.msg : "",
        user: {},
        token: null,
        isAuthenticated: false,
        verified: false,
      };
    case DELETE_USER_ACCOUNT_ERROR:
      localStorage.removeItem("token");
      return {
        ...state,
        msg: payload ? payload : "",
        user: {},
        token: null,
        isAuthenticated: false,
        verified: false,
      };
    case CLEAR_MSG:
      return {
        ...state,
        msg: "",
      };
    case REGISTER_FAIL:
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
    case DELETE_USER:
    case DELETE_USER_ERROR:
      localStorage.removeItem("token");
      return {
        ...state,
        isAuthenticated: false,
        isRegistered: false,
        channelid: "",
        jobtitle: "",
        companyname: "",
        location: {},
        verified: false,
        redirected: false,
        loading: true,
        user: {},
        users: [],
        subscription: false,
        posts: [],
        articles: [],
      };
    default:
      return state;
  }
}
